import React from 'react';
import { Link } from 'react-router-dom';

const HomeFact = () => {
   return (
      <>
         <section className="fact-area fact-map primary-bg pos-rel pt-115 pb-60">
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-10">
                     <div className="section-title pos-rel mb-45">
                        <div className="section-text section-text-white pos-rel">
                           <h5>Our online services are available 24/7</h5>
                           <h2 className="white-color">We Always Ready For A Challenge.</h2>
                        </div>
                     </div>
                     <div className="section-button section-button-left mb-30">
                        <Link to="/login" className="primary_btn btn-icon ml-0"><span>+</span>Book Appointment Now</Link>
                     </div>
                  </div>
                  <div className="col-lg-6 col-lg-6 col-md-8">
                     <div className="cta-satisfied">
                        <div className="single-satisfied mb-50">
                           <h3>100k</h3>
                           <h5> <i className="fas fa-user"></i> Registered Patients</h5>
                           <p>Our clinic have served 100,000+ registered patients and growing.</p>
                        </div>
                        <div className="single-satisfied mb-50">
                           <h3>2</h3>
                           <h5><i className="far fa-thumbs-up"></i> Local locations</h5>
                           <p>We have multiple local locations in Vancouver, BC.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeFact;